import { Button, Paragraph } from 'common-components'
import { useNavigate, useRouteError, isRouteErrorResponse } from 'react-router'
import styled from '@emotion/styled'

const ErrorPage = () => {
  const navigate = useNavigate()
  const error = useRouteError()

  let errorMessage: string

  if (isRouteErrorResponse(error)) {
    // error is type `ErrorResponse`
    errorMessage = error.statusText
  } else if (error instanceof Error) {
    errorMessage = error.message
  } else if (typeof error === 'string') {
    errorMessage = error
  } else {
    console.error(error)
    errorMessage = 'Unknown error'
  }

  const ErrorPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `

  return (
    <ErrorPageWrapper>
      <Paragraph>{errorMessage}</Paragraph>
      <Paragraph>404 not found error page</Paragraph>
      <Button onClick={() => navigate(-1)}>Go back</Button>
    </ErrorPageWrapper>
  )
}

export default ErrorPage
